import { useEffect } from 'react'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { useNotifications } from '@wallyhealth/web-core'
import { fetchAppointmentDetails, checkInForAppointment } from './api'
import config from 'config'

export const useAppointmentDetails = ({ encodedId }) => {
  const queryClient = useQueryClient()
  const notifications = useNotifications()

  useEffect(() => {
    if (!encodedId) {
      window.location.replace(config.HOMEPAGE_URL)
    }
  }, [encodedId])

  const queryKey = ['appointmentDetails', encodedId]

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey,
    queryFn: () => fetchAppointmentDetails({ encodedId }),
    enabled: !!encodedId,
    refetchOnWindowFocus: true,
    refetchInterval: 30000,
    retry: false
  })

  const isNotFound = isError && error?.status === 400

  const mutation = useMutation({
    mutationFn: () => checkInForAppointment({ encodedId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey })
    },
    onError: () => {
      notifications.error('Could not check in. Please try again.')
    }
  })

  return {
    isLoading,
    isNotFound,
    shouldRetryLoading: isError && !isNotFound,
    data: data ?? null,
    reload: refetch,
    isCheckingIn: mutation.isPending,
    handleCheckIn: () => mutation.mutateAsync()
  }
}
